import { SvgComponent } from "@/components/base/Svg"
import { useLoginAction } from "@/features/useSearchAction"
import { Favorite } from "@/features_signal/favorite"
import UserInfo from "@/features_signal/userInfo"
import styled from "@emotion/styled"
import { memo } from "react"

const Like = styled.div`
    width: 24rem;
    height: 24rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 8rem;
    right: 8rem;
    z-index: 1;
    cursor: pointer;
`
const IconLikeSvg = styled(SvgComponent("pages/HomePage/icon_like.svg"))``
const IconUnLikeSvg = styled(SvgComponent("pages/HomePage/icon_un_like.svg"))``

export const GameCardFavButton = memo(({ id = "" }: { id: string }) => {
    const { openModalToStep } = useLoginAction()

    return (
        <Like
            onClick={(e) => {
                e.stopPropagation()
                UserInfo.isLogin.value ? Favorite.toggleFav(id) : openModalToStep("login-otp-1")
            }}
        >
            {Favorite.favMap.value.get(id) ? <IconLikeSvg /> : <IconUnLikeSvg />}
        </Like>
    )
})
